import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS
} from "@angular/material/core";
import {RouterModule} from "@angular/router";
import {TooltipModule} from "ng2-tooltip-directive";
import {DeleteComponent} from '../modals/delete/delete.component';
import {PageTitleService} from '../core/components/page-title/page-title.service';
import {LoaderComponent} from "./component/loader/loader.component";
import {TranslateModule} from "@ngx-translate/core";
import {DataTableComponent} from "./component/data-table/data-table.component";
import {ScrollbarModule} from "../../@config/components/scrollbar/scrollbar.module";
import {ExcelService} from "../services/excel.service";
import {PageLayoutModule} from 'src/@config/components/page-layout/page-layout.module';
import {CustomBreadcrumbsModule} from 'src/@config/components/breadcrumbs/custom-breadcrumbs.module';
import {PhoneWithCountryComponent} from "./component/phone-with-country/phone-with-country.component";
import {NgxIntlTelInputModule} from "ngx-intl-tel-input";
import {FilterComponent} from './component/filter/filter.component';
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import {ImageViewerModule} from "@nghacks/image-viewer";
import {DateFormatPipe} from "../pipes/date-formate.pipe";
import {
  DateLocaleKeys,
  MOMENT_HIJRI_DATE_FORMATS,
  NgxAngularMaterialHijriAdapterService
} from "ngx-angular-material-hijri-adapter";
import {GetLanguage, GetPreferredDate} from "./functions/shared-functions";
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from "@angular/material-moment-adapter";
import {ArabicInEnglishError} from "../pipes/arabic-in-english-error";
import {EnglishInArabicErrorPipe} from "../pipes/english-in-arabic-error.pipe";
import {CalendarPipe} from "../pipes/calendar.pipe";
import {AngularMaterialModule} from "./material.module";
import {MatFormFieldModule} from "@angular/material/form-field";
import {UsersListComponent} from "../modules/users/users-list/users-list.component";
import { NotFoundComponent } from './component/not-found/not-found.component';

@NgModule({
  declarations: [
    LoaderComponent,
    DataTableComponent,
    DeleteComponent,
    PhoneWithCountryComponent,
    FilterComponent,
    DateFormatPipe,
    ArabicInEnglishError,
    EnglishInArabicErrorPipe,
    CalendarPipe,
    UsersListComponent,
    NotFoundComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientModule,
    DataTableComponent,
    DeleteComponent,
    LoaderComponent,
    TooltipModule,
    PageLayoutModule,
    CustomBreadcrumbsModule,
    PhoneWithCountryComponent,
    FilterComponent,
    DateFormatPipe,
    ArabicInEnglishError,
    EnglishInArabicErrorPipe,
    CalendarPipe,
    TranslateModule,
    RouterModule,
    UsersListComponent,
  ],
  imports: [
    PageLayoutModule,
    CustomBreadcrumbsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TooltipModule,
    RouterModule,
    TooltipModule,
    TranslateModule,
    ScrollbarModule,
    NgxIntlTelInputModule,
    NgMultiSelectDropDownModule,
    ImageViewerModule,
    MatFormFieldModule,
    AngularMaterialModule,
  ],
  providers: [
    PageTitleService,
    ExcelService,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: GetLanguage() === DateLocaleKeys.AR ? (GetPreferredDate() === '2' ? NgxAngularMaterialHijriAdapterService : MomentDateAdapter) : MomentDateAdapter,
    },
    // Change the format by using `MOMENT_HIJRI_DATE_FORMATS` for Dates and `MOMENT_HIJRI_DATE_TIME_FORMATS` for date/time.
    {
      provide: MAT_DATE_FORMATS,
      useValue: GetLanguage() === DateLocaleKeys.AR ? (GetPreferredDate() === '2' ? MOMENT_HIJRI_DATE_FORMATS : MAT_MOMENT_DATE_FORMATS) : MAT_MOMENT_DATE_FORMATS
    },
    // Change the localization to arabic by using `AR_SA` not `AR` only and `EN_US` not `EN` only.
    {
      provide: MAT_DATE_LOCALE,
      useValue: GetLanguage() === DateLocaleKeys.AR ? (GetPreferredDate() === '2' ? DateLocaleKeys.AR_SA : DateLocaleKeys.AR) : DateLocaleKeys.EN_US
    },
  ]
})
export class SharedModule {
}
